import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useProducts } from '../../Context/ProductContext';
import './HomepageBestsellers.css';

const HomepageBestsellers = () => {
  const { products: allProducts, isLoading } = useProducts();
  const sliderRef = useRef(null);

  // Filter for bestsellers
  const bestSellerProducts = allProducts.filter(
    p => p.isBestSeller === true || p.isBestseller === true
  );

  const productsToShow = bestSellerProducts.length > 0 ? bestSellerProducts : allProducts.slice(0, 8);

  if (isLoading || productsToShow.length === 0) return null;

  // Native Scroll function for Desktop Arrows
  const scroll = (direction) => {
    if (sliderRef.current) {
      const scrollAmount = direction === 'left' ? -350 : 350;
      sliderRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section className="hb-section" id="homepage-bestsellers">
      {/* Heading matching the brownish tone from your design */}
      
      <div className="hb-slider-container relative">
        
        {/* Desktop Previous Arrow */}
        <button className="hb-arrow hb-prev-arrow hidden md:block" onClick={() => scroll('left')} type="button" aria-label="Previous">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>

        {/* Native CSS Scroll Track */}
        <div className="hb-track" ref={sliderRef}>
          {productsToShow.map((p) => {
            const rawMRP = p?.variants?.[0]?.mrp || p?.mrp || '0'; 
            const mrp = String(rawMRP).includes('₹') ? rawMRP : `₹ ${rawMRP}`; 
            
            const rawPrice = p?.variants?.[0]?.price || p?.price || rawMRP;
            const sellPrice = String(rawPrice).includes('₹') ? rawPrice : `₹ ${rawPrice}`;

            const numMRP = parseInt(String(mrp).replace(/[₹, ]/g, '')) || 0;
            const numPrice = parseInt(String(sellPrice).replace(/[₹, ]/g, '')) || 0;
            
            let discountPercent = 0;
            if (numMRP > numPrice && numMRP > 0) {
              discountPercent = Math.round(((numMRP - numPrice) / numMRP) * 100);
            }

            return (
              <div className="hb-slide" key={p.id}>
                <div className="hb-card">
                  <Link to={`/product/${p.slug || p.id}`} className="hb-image-link">
                    <div className="hb-image-wrapper">
                      
                      {/* Discount Badge matching screenshot (Light beige, top left) */}
                      {discountPercent > 0 && (
                        <div className="discount-badge">{discountPercent}% OFF</div>
                      )}
                      
                      {/* Primary Image with rounded corners */}
                      {p?.images?.[0] && (
                        <img 
                          src={p.images[0]} 
                          alt={p.title || 'Product Image'} 
                          className="hb-img-primary" 
                          loading="lazy"
                        />
                      )}

                      {/* Hover Image Reveal */}
                      {p?.images?.[1] && (
                        <img 
                          src={p.images[1]} 
                          alt={`${p.title || 'Product'} Hover`} 
                          className="hb-img-hover" 
                          loading="lazy"
                        />
                      )}
                    </div>
                  </Link>

                  {/* Product Details below image */}
                  <div className="hb-meta">
                    <h3 className="hb-title">{p.title}</h3>
                    
                    <div className="hb-price-row">
                      <span className="hb-sell-price">{sellPrice}</span>
                      {discountPercent > 0 && (
                        <span className="hb-mrp">{mrp}</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Desktop Next Arrow */}
        <button className="hb-arrow hb-next-arrow hidden md:block" onClick={() => scroll('right')} type="button" aria-label="Next">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>

      </div>
    </section>
  );
};

export default HomepageBestsellers;